import { Navigate } from 'react-router-dom';
import { SettingsPage } from './pages/SettingsPage';
import { SettingsPersonalPage } from './pages/SettingsPersonalPage';
import { SettingsHouseholdPage } from './pages/SettingsHouseholdPage';
import { SettingsEmojisPage } from './pages/SettingsEmojisPage';
import { SettingsTagsPage } from './pages/SettingsTagsPage';
import { SettingsEventsPage } from './pages/SettingsEventsPage';

export const settingsRoutes = {
  path: 'settings',
  element: <SettingsPage />,  
  children: [{
    path: '',
    element: <Navigate to="personal" replace={true} />,
  }, {
    path: 'personal',
    element: <SettingsPersonalPage />,   
  }, {
    path: 'household',
    element: <SettingsHouseholdPage />,   
  }, {
    path: 'emojis',
    element: <SettingsEmojisPage />,   
  }, {
    path: 'tags',
    element: <SettingsTagsPage />,
  }, {
    path: 'events',
    element: <SettingsEventsPage />,
  }],
};
